import React from "react";

// Education Data
const educationContent = [
  {
    year: "2021-2023",
    degree: "LLM (Business Law)",
    institute: "Dr. Babasahed Ambedkar Marathvada University",
    details: `LLM in Business Law, specializing in corporate law, legal analysis, and regulatory compliance.`,
  },
  {
    year: "2016-2021",
    degree: "LLB",
    institute: "Dr. Babasahed Ambedkar Marathvada University",
    details: `Focusing on foundational legal principles, case analysis, and statutory interpretation.`,
  },
  {
    year: "2004",
    degree: "Certification in AI Marketing",
    institute: "IIT Rourkee",
    details: `Specializing in leveraging artificial intelligence to enhance marketing strategies, customer insights, and data-driven decision-making.`,
  },
];

// Experience Data
const experienceContent = [
  {
    year: "2024 - Present",
    position: "Co-founder",
    companyName: "VictoryCineworld",
    details: `Co-founder at Victory Cineworld, driving strategic growth and innovative media solutions.`,
  },
  {
    year: "2019 - Present",
    position: "Founder, Partner",
    companyName: "Buzzlink Studios LLP",
    details: `Delivering cutting-edge IT solutions in web development, app creation, and digital marketing.`,
  },
  {
    year: "2017 - 2019",
    position: "Legal Associate",
    companyName: "Karner & Co.",
    details: `Specializing in legal research, document drafting, and client representation.`,
  },
];

// Component
const Exp = () => {
  return (
    <div className="space-y-8">

      
      {/* Experience Section */}
      <div>
        <h3 className="text-2xl font-bold text-center mb-16">Experience</h3>
        <div className="space-y-4">
          {experienceContent.map((val, i) => (
            <div key={i}>
              <span className="block text-sm text-gray-500">{val.year}</span>
              <h4 className="text-lg font-semibold text-gray-800">{val.position}</h4>
              <p className="text-gray-700">{val.companyName}</p>
              <p className="text-gray-600 text-sm mt-1">{val.details}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Education Section */}
      <div>
        <h3 className="text-2xl font-bold text-center mb-6 mt-8">Education</h3>
        <div className="space-y-4">
          {educationContent.map((val, i) => (
            <div key={i}>
              <span className="block text-sm text-gray-500">{val.year}</span>
              <h4 className="text-lg font-semibold text-gray-800">{val.degree}</h4>
              <p className="text-gray-700">{val.institute}</p>
              <p className="text-gray-600 text-sm mt-1">{val.details}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Exp;
